export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_PERMISOS_REQUEST = 'AUTH_PERMISOS_REQUEST';
export const AUTH_PERMISOS_SUCCESS = 'AUTH_PERMISOS_SUCCESS';
export const AUTH_PERMISOS_FAILURE = 'AUTH_PERMISOS_FAILURE';

export const AUTH_RECOVER_REQUEST = 'AUTH_RECOVER_REQUEST';
export const AUTH_RECOVER_SUCCESS = 'AUTH_RECOVER_SUCCESS';
export const AUTH_RECOVER_FAILURE = 'AUTH_RECOVER_FAILURE';
